﻿import {hasFlag, translation} from "@2d-front-monorepo/core";
import {IMvvmContextState, MvvmTextInput} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import DriverPropertyFlags from "../enums/DriverPropertyFlags";
import {useFieldValidation} from "../helpers/useFieldValidation";
import ICreateComponentAttachments from "../interfaces/ICreateComponentAttachments";
import {CreateDriverArguments} from "../types/arguments/CreateDriverArguments";
import {EntityProfile} from "../types/InstallationByHostData";
import {ComponentWithChildrenParts} from "./ComponentParts";
import FullCreateAttachmentsComponent from "./FullCreateAttachmentsComponent";

export interface CreateDriverComponentProps extends ComponentWithChildrenParts<CreateDriverModel> {
	configuration: EntityProfile<DriverPropertyFlags>;
	context: IMvvmContextState<CreateDriverModel>;
}

export interface CreateDriverModel extends ICreateComponentAttachments {
	arguments: CreateDriverArguments;
	customData: Record<string, any>;
}

export default function CreateDriverComponent(props: CreateDriverComponentProps): JSX.Element {
	const {
		context,
		configuration,
		header,
		children,
		footer
	} = props;

	const readOnlyFields = configuration.fieldRules.readOnly || DriverPropertyFlags.None;
	const hiddenFields = configuration.fieldRules.hidden || DriverPropertyFlags.None;

	const fullNameValidation = useFieldValidation<DriverPropertyFlags, string>(configuration.fieldRules, DriverPropertyFlags.Fullname, "driver", "full-name");
	const licenseNumberValidation = useFieldValidation<DriverPropertyFlags, string>(configuration.fieldRules, DriverPropertyFlags.LicenseNumber, "driver", "license-number");

	return (<div className="layout vertical gap">
		{header?.(context.state)}
		<div className="grid">
			<MvvmTextInput context={context}
			               property="arguments.fullName"
			               type="text"
			               column="col-1of2"
			               autoFocus
			               hidden={hasFlag(hiddenFields, DriverPropertyFlags.Fullname)}
			               disabled={hasFlag(readOnlyFields, DriverPropertyFlags.Fullname)}
			               validation={fullNameValidation.validation}
			               transform={fullNameValidation.transform}
			               minLength={fullNameValidation.minLength}
			               maxLength={fullNameValidation.maxLength}
			               label={translation(PermitTranslations.new_driver__full_name)}/>

			<MvvmTextInput context={context}
			               property="arguments.licenseNumber"
			               type="text"
			               column="col-1of2"
			               hidden={hasFlag(hiddenFields, DriverPropertyFlags.LicenseNumber)}
			               disabled={hasFlag(readOnlyFields, DriverPropertyFlags.LicenseNumber)}
			               validation={licenseNumberValidation.validation}
			               transform={licenseNumberValidation.transform}
			               minLength={licenseNumberValidation.minLength}
			               maxLength={licenseNumberValidation.maxLength}
			               label={translation(PermitTranslations.new_driver__license_number)}/>

		</div>
		{children}
		<FullCreateAttachmentsComponent context={context} attachments={configuration.attachments}/>
		{footer?.(context.state)}
	</div>);
}
